import { ObservableArray, View } from "binder"
import { NoSaleLockReportsViewModel, noSaleLockRow } from "./noSaleLockReports-viewModel"

export class NoSaleLockReportsView extends View<NoSaleLockReportsViewModel>{
    GetViewUniqueId(): string {
        return "V-EC9D4813-AA8A-42D3-B6EE-8B4941A1C72D"
    }
    loadHtml(): string {
        let element = require('./noSaleLockReports.html').default;
        let style = require('./noSaleLockReports.less');
        return element;
    }
    constructor() {
       super();
    }
    
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set reportRows(v: ObservableArray<noSaleLockRow>) { this._reportRows = v; } public get reportRows(): ObservableArray<noSaleLockRow> { return this._reportRows;} private _reportRows: ObservableArray<noSaleLockRow>;
   
    public set from(v: moment.Moment) { this._from = v;} public get from(): moment.Moment { return this._from;} private _from: moment.Moment;
    public set until(v: moment.Moment) { this._until = v;} public get until(): moment.Moment { return this._until;} private _until: moment.Moment;

    load(){
        this.dataContext.refresh();
    }
}
